export const euroDePlusProps = () => ({
  fraisLivraison: {
    type: Number,
    required: false,
    default: 8.9
  }
})
